import type {PropsWithChildren} from 'react'
import {createContext, useContext} from 'react'

type PageContextType = {
  funnelType?: string | null
}

type PageContextProviderProps = PropsWithChildren & {
  funnelType?: string | null
}

const PageContext = createContext<PageContextType | null>(null)

const PageContextProvider = ({children, funnelType}: PageContextProviderProps) => {
  const value: PageContextType = {
    funnelType,
  }

  return <PageContext.Provider value={value}>{children}</PageContext.Provider>
}

const usePageContext = () => {
  const context = useContext(PageContext)

  if (context === null) {
    // Return default values instead of throwing to prevent app crashes
    console.warn(
      'usePageContext: Context not found. Make sure component is wrapped with PageContextProvider. Using default values.',
    )

    return {
      funnelType: null,
    }
  }

  return context
}

export {PageContext, PageContextProvider, usePageContext}
export type {PageContextType}
